
import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _QualityReprocessingItem, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import useModal, { MODAL_LG, MODAL_md, MODAL_SM, MODAL_XL } from "../../../../theme/Component/hooks/useModal";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicTable, MASK_DATE } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { AccountEditor } from "../../../../editor/AccountEditor";
import { SelectLabour } from "../../../ManufacturingStandars/Labour/SelectLabour";
import { Alert } from "../../../../theme/Component/Alert";
import usePaginator from "../../../../theme/Component/usePaginator";
import { SelectQualityErrorTypes } from "../../QualityErrors/SelectQualityErrorTypes";
import { SelectQualityErrorDetails } from "../../QualityErrors/QualityErrorDetails/SelectQualityErrorDetails";
import { DropDown } from "../../../../theme/Component/DropDown";
import { ExportXLSL } from "../../../../theme/Component/ExportXLSX";
import { InputDate } from "../../../../theme/Input/InputDate";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { ProductionRouteSelect } from "../../../ProductionRoute/ProductionRouteSelect";
import { ImportXLSX } from "../../../../theme/Component/ImportXLSX";
import { PrintJson } from "../../../../theme/Component/PrintJson";
import { SelectTHConstantsValue } from "../../../../bpm/config/Componentes/SelectTHConstantsValue";


interface componentData {
    QualityReprocessing: any;
    isReport?: boolean;
}

interface formData {
    From: any;
    Upto: any;
    State: number;
    IDAccount: number;
    Route: number;
    Labour: number;
    Error: number;
    TypeError: number;
    turn: number;
}

export const QualityReprocessingItem = ({ isReport, QualityReprocessing }: componentData) => {

    const { instance, setBean, bean, lista, setLista } = useDataBean(_QualityReprocessingItem)
    const paginator = usePaginator();

    const [listaProces, setListaProces] = useState<any[]>([]);
    const [listaExport, setListaExport] = useState<any[]>([]);
    const [form, setForm] = useState<Partial<formData>>({
        State: 1,
    })

    const modal = useModal("", MODAL_LG);
    const modalC = useModal("Eliminar Inspección", MODAL_SM);;
    const modalGraph = useModal("Reporte Excel", MODAL_SM);
    const modalProces = useModal("Procesos Listados", MODAL_md);
    const modalImport = useModal("Importar Reprocesos", MODAL_md);

    const head = [
        { title: 'ID', property: 'IDQualityReprocessingItem', visible: true },
        { title: 'Turno', property: 'WorkShiftNameFather', visible: QualityReprocessing?.IDQualityReprocessing ? false : true },
        { title: 'Operario', property: 'EntityUser', visible: true },
        { title: 'Numero de Pieza', property: 'NumberPiece', visible: true },
        { title: 'Ruta', property: 'ProductionRouteName', visible: QualityReprocessing?.IDQualityReprocessing ? false : true },
        { title: 'Proceso', property: 'LabourName', visible: true },
        { title: 'Tiempo de ejecución de Proceso', property: 'Quantity', visible: true },
        { title: 'Tipo de Error', property: 'ErrorTypeName', visible: true },
        { title: 'Error', property: 'EntityError', visible: true },
        { title: 'Motivo', property: 'ErrorDetailCause', visible: true },
        { title: 'Fecha', property: 'ReviewDateFrom', visible: true, mask: MASK_DATE },
    ];

    const getListaProces = () => {
        setListaProces([]);
        const props = {
            IDQualityReprocessing: QualityReprocessing?.IDQualityReprocessing,
        }
        instance.getQualityReprocessingItemCountByLabour(null, null, props, form.From, form.Upto).then(
            (resp) => {

                resp.List.forEach(element => {
                    const data = element.DataBeanProperties;

                    data.EntityTime = data.LabourCount * data.Quantity
                });

                setListaProces(resp.List);
                modalProces.open();
            }
        ).catch(err => { toast.error(err) })
    }

    const getListaExport = () => {
        const props: any = {
            IDQualityReprocessing: QualityReprocessing?.IDQualityReprocessing,
            State: 1
        }

        if (form.IDAccount) props.IDAccountOperator = form.IDAccount;
        if (form.Route) props.IDProductionRoute = form.Route;
        if (form.Labour) props.IDLabour = form.Labour;
        if (form.Error) props.IDQualityErrorDetails = form.Error;
        if (form.TypeError) props.IDQualityErrorTypes = form.TypeError;
        if (form.turn) props.IDWorkShiftFather = form.turn;

        instance.getQualityReprocessingItemRender(1, paginator.pages * 15, props, form.From, form.Upto).then(
            (resp) => {
                resp.List.forEach(element => {
                    const data = element.DataBeanProperties;
                    data.EntityUser = data.IDAccountOperator ? `${data.OperatorNit} - ${data.OperatorEntityName}` : "N/A";
                    data.EntityError = data.IDQualityErrorDetails ? `${data.ErrorDetailCode} - ${data.ErrorDetailName}` : "N/A";
                });
                setListaExport(resp.List)
                modalGraph.open();
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const actionsDropDown = [
        { id: 1, name: 'Reporte Excel', permiso: null, activo: true },
        { id: 2, name: 'Listado de Procesos', permiso: null, activo: true },
    ];
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={(e) => {
                        if (e.id == 1) {
                            getListaExport();
                        }
                        if (e.id == 2) {
                            getListaProces();
                        }
                    }} />
                </div>
            </div>
        )
    }

    useEffect(() => {
        if (QualityReprocessing?.IDQualityReprocessing) {
            getLista();
        } else if (isReport) {
            getLista();
        }
    }, [QualityReprocessing?.IDQualityReprocessing, paginator.page])

    const getLista = () => {
        const props: any = {
            IDQualityReprocessing: QualityReprocessing?.IDQualityReprocessing,
            State: 1
        }

        if (form.IDAccount) props.IDAccountOperator = form.IDAccount;
        if (form.Route) props.IDProductionRoute = form.Route;
        if (form.Labour) props.IDLabour = form.Labour;
        if (form.Error) props.IDQualityErrorDetails = form.Error;
        if (form.TypeError) props.IDQualityErrorTypes = form.TypeError;
        if (form.turn) props.IDWorkShiftFather = form.turn;

        instance.getQualityReprocessingItemRender(paginator.page, 15, props, form.From, form.Upto).then(
            (resp) => {
                paginator.setPages(resp.NumberOfPages);
                paginator.setRecords(resp.NumberOfPages * 15);
                resp.List.forEach(element => {
                    const data = element.DataBeanProperties;
                    data.EntityUser = data.IDAccountOperator ? `${data.OperatorNit} - ${data.OperatorEntityName}` : "N/A";
                    data.EntityError = data.IDQualityErrorDetails ? `${data.ErrorDetailCode} - ${data.ErrorDetailName}` : "N/A";
                });
                setLista(resp.List)
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const deleteItem = () => {
        let x = { ...bean, State: 2 };
        instance.updateQualityReprocessingItem(x).then(
            (resp) => {
                getLista();
                modalC.close();
            }
        ).catch(err => { toast.error(err) });
    };

    const create = () => {
        setBean({
            IDQualityReprocessing: QualityReprocessing?.IDQualityReprocessing,
            State: 1,
            IDEmployee: _single.getAccountID(),
            IDProduct: QualityReprocessing?.IDProduct,
        });
        modal.open("Agregar Norma o Especificación");
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate() && (!isReport), icono: 'ri-file-add-line', evento: create },
        { nombre: 'Importar', visible: _single.canCreate() && (!isReport), icono: 'ri-file-upload-line', evento: () => { modalImport.open(); } }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit() && (!isReport), evento: () => { modal.open("Editar Norma o Especificación") } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete() && (!isReport), evento: () => { modalC.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            saveMultipleItems();
        }
    };

    const saveMultipleItems = async () => {
        for (const piece of numberPieces.filter(p => p !== "")) {
            const obj = { ...bean, NumberPiece: piece };

            try {
                await instance.updateQualityReprocessingItem(obj);
                toast.success(`Registro guardado correctamente para la pieza ${piece}`);
            } catch (err: any) {
                toast.error(`Error guardando la pieza ${piece}: ${err.message || err}`);
            }
        }

        getLista();
        modal.close();
        modalC.close();
        setNumberPieces([""]);
    };


    const importData = () => {

        const yearOrder = new Date(QualityReprocessing?.ProductionOrderDate).getFullYear();

        instance.importReprocessReviewItems(_single.getAccountID(), JSON.stringify(data), QualityReprocessing?.IDQualityReprocessing, yearOrder).then(
            (resp: any) => {
                getLista();
                modalImport.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const validateForm = () => {
        const requiredFields = ["IDLabour", "IDQualityErrorDetails", "IDAccountOperator"];
        let missing = [];

        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }

        if (numberPieces.filter(p => p !== "").length === 0) {
            missing.push("NumberPiece");
        }

        setMissingFields(missing);
        return missing.length;
    };


    const head2 = [
        { title: 'Proceso', property: 'LabourName', visible: true },
        { title: 'Cantidad', property: 'LabourCount', visible: true },
        { title: 'Tiempo de Repoceso (m)', property: 'EntityTime', visible: true },
    ]

    const [data, setData] = useState<string>('');
    const [numberPieces, setNumberPieces] = useState<string[]>([""]);

    return (
        <div className="row">
            {isReport &&
                <>
                    <div className="col-md-4">
                        <InputDate name="" value={form.From} setDate={(e) => { setForm({ ...form, From: e }) }} label="Desde" />
                    </div>
                    <div className="col-md-4">
                        <InputDate name="" value={form.Upto} setDate={(e) => { setForm({ ...form, Upto: e }) }} label="Hasta" />
                    </div>
                    <div className="col-md-4">
                        <AccountEditor idAccount={form.IDAccount} label="Operario" onChange={(e) => { setForm({ ...form, IDAccount: e.IDAccount }) }} />
                    </div>
                    <div className="col-md-6">
                        <ProductionRouteSelect idSelector={form.Route} onChange={(e) => { setForm({ ...form, Route: e }) }} label="Ruteo" />
                    </div>

                    <div className="col-md-6">
                        <SelectLabour IDProductionRoute={form.Route} idSelector={form.Labour} onChange={(e) => { setForm({ ...form, Labour: e }) }} label="Labor" />
                    </div>
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-6">
                                <SelectQualityErrorTypes idSelector={form.TypeError} onChange={(e) => { setForm({ ...form, TypeError: e }) }} label="Tipo de Error" />
                            </div>
                            <div className="col-md-6">
                                <SelectQualityErrorDetails idSelector={form.Error} onChange={(e) => { setForm({ ...form, Error: e }) }} idErrorType={form.TypeError} label="Error" />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <SelectTHConstantsValue label="Turno de Trabajo" code={904} onChange={(e) => { setForm({ ...form, turn: e }) }} value={form.turn} />
                    </div>

                    <div className="col-md-2">
                        <BasicButton useMargin eventClick={() => { getLista() }} icon="ri-search-line" children={`Buscar`} />
                    </div>
                </>
            }
            <div className="col-md-12">
                <BasicTable
                    headButtons={buttons()}
                    body={lista}
                    head={head}
                    rowSet={setBean}
                    iconButtons={iconButtonsItem}
                    listButtons={listaBotones()}
                    pageTop={paginator.page}
                    next={paginator.next}
                    back={paginator.back}
                    records={paginator}
                />
            </div>

            <div className="col-md-12">
                <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { validateData() }} >
                    <div className="row">
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IDAccountOperator') ? 'has-error' : ''}`}>Operador</label>
                            <AccountEditor idAccount={bean.IDAccountOperator} label=" " onChange={(e) => { setBean({ ...bean, IDAccountOperator: e.IDAccount }) }} />
                        </div>

                        {QualityReprocessing.IDProductionRoute ?
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('IDLabour') ? 'has-error' : ''}`} >Operación</label>
                                <SelectLabour IDProductionRoute={QualityReprocessing.IDProductionRoute} label=" " idSelector={bean.IDLabour} onChange={(e) => { setBean({ ...bean, IDLabour: e }) }} />
                            </div>
                            :
                            
                            <Alert children={"No Presenta ruteos"} clase="warning" />
                        }
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-6">
                                    <SelectQualityErrorTypes idSelector={bean.IDQualityErrorTypes} onChange={(e) => { setBean({ ...bean, IDQualityErrorTypes: e }) }} label="Tipo de Error" />
                                </div>
                                {bean.IDQualityErrorTypes &&
                                    <div className="col-md-6">
                                        <SelectQualityErrorDetails returnType="Object" idSelector={bean.IDQualityErrorDetails} onChange={(e) => { setBean({ ...bean, IDQualityErrorDetails: e.IDQualityErrorDetails, Reason: e.Cause }) }} idErrorType={bean.IDQualityErrorTypes} label="Error" />
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="col-md-12">
                            <label className={`${missingFields.includes('NumberPiece') ? 'has-error' : ''}`}>
                                Números de Piezas
                            </label>
                            <div className="row">

                                {numberPieces.map((piece, index) => (
                                    <div key={index} className="col-md-6 mb-2">
                                        <div className="input-group">
                                            <input
                                                type="number"
                                                value={piece}
                                                onChange={(e) => {
                                                    const newPieces = [...numberPieces];
                                                    newPieces[index] = e.target.value;
                                                    setNumberPieces(newPieces);
                                                }}
                                                className="form-control"
                                            />

                                            {index === numberPieces.length - 1 && (
                                                <button
                                                    type="button"
                                                    className="btn btn-success"
                                                    onClick={() => setNumberPieces([...numberPieces, ""])}
                                                >
                                                    +
                                                </button>
                                            )}

                                            {numberPieces.length > 1 && (
                                                <button
                                                    type="button"
                                                    className="btn btn-danger"
                                                    onClick={() => {
                                                        const newPieces = numberPieces.filter((_, i) => i !== index);
                                                        setNumberPieces(newPieces);
                                                    }}
                                                >
                                                    x
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="col-md-12">
                            <label className={`${missingFields.includes('Reason') ? 'has-error' : ''}`}>Motivo del reproceso</label>
                            <textarea value={bean.Reason} disabled className="form-control" />
                        </div>

                    </div>
                </Modal>

                <Modal modal={modalGraph.modal} updateModal={modalGraph.setModal}>
                    <div className="row">
                        <div className="col">
                            {lista.length > 0 &&
                                <ExportXLSL customName={"Reprocesos"} optionIcon="ri-download-cloud-2-line text-success" title={head} data={listaExport} onExport={(name: string) => {
                                    _single.download("formato xlsx [" + name + "] con " + lista.length + " registros");
                                }} />
                            }
                        </div>
                    </div>
                </Modal>

                <Modal modal={modalImport.modal} updateModal={modalImport.setModal} eventModal={() => { importData() }}  >
                    <ImportXLSX lodaData={setData} />
                </Modal>

                <Modal modal={modalProces.modal} updateModal={modalProces.setModal}>
                    <div className="row">
                        <div className="col-md-12">
                            <BasicTable body={listaProces} head={head2} rowSet={() => { }} />
                        </div>
                    </div>
                </Modal>

                <ModalConfirm eventModal={() => { deleteItem() }} updateModal={modalC.setModal} modal={modalC.modal} >
                    <strong>¿Desea Continuar con la accion?</strong>
                </ModalConfirm>
            </div>
        </div>
    )
}